import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

/**
 * Charge une ressource admin. En cas d'echec, data reste null : c'est ce
 * signal (et non une valeur par defaut) que les modules doivent utiliser
 * pour afficher un etat "non disponible" plutot qu'une donnee inventee.
 */
export default function useAdminData(fetcher, deps) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      setData(await fetcher());
    } catch (error) {
      setData(null);
      toast.error(error.response?.data?.message || t("admin.request_error"));
    } finally {
      setLoading(false);
    }
  }, [t, ...deps]);
  useEffect(() => { load(); }, [load]);
  return { data, setData, loading };
}
